import React from 'react';
import Heading from './Heading';

interface INavItem {
    id: string;
    title: string;
    titleClassName: string;
    titleClassNameSelected: string;
    wrapperClassName: string;
    wrapperClassNameSelected: string;
    isDisabled?: boolean;
}
interface IProps {
navItems: INavItem[];
wrapperClassName: string;
activeTabId?: string;
onSwitch: (switchId:string) => void;
}

export const SwitchNav = ({
  navItems, wrapperClassName, activeTabId, onSwitch,
}: IProps) => (
  <div className={wrapperClassName}>
    {navItems.map(item => (
      <button
        disabled={item?.isDisabled || false}
        id={item.id}
        onClick={() => onSwitch(item.id)}
        type='button'
        className={` ${item.id === activeTabId ? item.wrapperClassNameSelected : item.wrapperClassName} ${item?.isDisabled ? 'cursor-default' : ''}`}
        key={item.id}
      >
        <Heading title={item.title} className={`${item.id === activeTabId ? item.titleClassNameSelected : item.titleClassName} ${item?.isDisabled ? 'cursor-default' : ''}`} />
      </button>
    ))}
  </div>
);
